type Revision = { revision: number };

export interface CustomRevisionSelection {
  productId: string;
  latestRevision: number;
  revision: number;
}

export function latestCustomProductRevision(revisions: readonly Revision[]): number {
  // The product counter can contain gaps after a failed insert. Select only rows
  // that exist, independent of their response order.
  return revisions.reduce((latest, item) => Math.max(latest, item.revision), 0);
}

export function selectedCustomProductRevision(
  productId: string,
  revisions: readonly Revision[],
  selection: CustomRevisionSelection | null,
): number {
  const latest = latestCustomProductRevision(revisions);
  if (selection?.productId === productId
    && selection.latestRevision === latest
    && revisions.some(item => item.revision === selection.revision)) {
    return selection.revision;
  }
  return latest;
}
